import styled from 'styled-components';

const HomesForYouStyles = styled.article`
  position: relative;
  @media screen and (min-width: 1100px) {
    padding-bottom: 40px;
  }
  .cta-container {
    position: relative;
    max-width: 1138px;
    padding: 0px 40px;
    margin: 0 auto;
    margin-bottom: 30px;
    @media screen and (max-width: 1099px) {
      padding: 0px 20px;
    }
  }
  .DXHero {
    margin-bottom: 60px;
  }
  .DXHero-backdrop {
    max-height: none !important;
  }
  .DXHero-container {
    @media screen and (max-width: 1015px) {
      width: 100%;
      max-width: 500px !important;
    }
    .button-wrap {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      a {
        font-weight: 600;
        font-family: 'source-sans-pro';
      }
    }
    .hero-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 13px 17px;
      background-color: transparent;
      color: white;
      text-decoration: none;
      border: 1px solid white;
      border-radius: 2px;
      text-transform: uppercase;
      letter-spacing: 1px;
      font: 700 12px/100% 'source-sans-pro', sans-serif;
      margin-right: 7px;
      margin-top: 10px;
      transition: 0.2s;
      &:hover {
        background: rgba(255, 255, 255, 0.12);
      }
    }
  }
  .DXHero {
    @media screen and (max-width: 1099px) {
      padding: 40px 20px 30px;
    }
    .DXHero-content {
      h1,
      h2,
      p {
        color: white;
        font-family: 'source-sans-pro';
      }
      h1 {
        font-weight: 600;
        font-size: 40px;
        line-height: 48px;
        margin: 0px 0px 10px 0px !important;
        @media screen and (max-width: 1099px) {
          font-weight: 600;
          font-size: 34px;
          line-height: 40px;
          letter-spacing: -0.2975px;
        }
      }
      .large-p {
        font-weight: 400;
        font-size: 18px;
        line-height: 27px;
        @media screen and (max-width: 1099px) {
          font-size: 16px;
          line-height: 27px;
        }
      }
      .small-p {
        font-size: 16px;
        line-height: 27px;
        @media screen and (max-width: 1099px) {
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
  }
  .container {
    display: flex;
    position: relative;
    max-width: 1108px;
    padding: 0px 25px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }
  .DXItemsGrid-grid {
    gap: 0px;
    margin: auto -10px;
    .DXTooltip-content {
      left: -90px;
    }
  }
  .DXItemsGrid {
    position: relative;
    /* margin: 40px 0px;
    @media screen and (max-width: 1099px) {
      margin: 40px 0px;
    } */
    .DXItemsGrid-heading {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      letter-spacing: -0.35px;
      color: #25292d;
      margin-bottom: 2px;
    }
    .DXItemsGrid-subheading {
      margin-bottom: 10px;
      @media screen and (max-width: 1099px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  /* .grid-container {
    position: relative;
    max-width: 1138px;
    padding: 0px 40px;
    margin: 0 auto;
    height: 100%;
    @media screen and (max-width: 1099px) {
      padding: 0px 20px;
    }
  } */
`;

export default HomesForYouStyles;
